import Action from "../../classes/Action";
import { deepEqual, JsonCopy } from "../../classes/utilities/Misc";
import AssetsLibraryUtilities from "../../components/filebrowser/AssetsLibraryUtilities";
import { IGrapesJSProjectData, VisageEditorWindowModes } from "../../interfaces/VisageUI";
import store, { StoreActions } from "../../state/store";

interface ISetGrapesProjectActionParams
{
	grapesProjectId?: string,
	newData: IGrapesJSProjectData,
	actionName?: string,
}

export default class SetGrapesProjectAction extends Action
{
	constructor(params: ISetGrapesProjectActionParams)
	{
		params.grapesProjectId = params.grapesProjectId || store.getState().visageModule.editorContext.projectId;
		const editorMode = store.getState().visageModule.editorMode;
		let oldData: IGrapesJSProjectData;
		switch(editorMode)
		{
			case VisageEditorWindowModes.Step:
				oldData = store.getState().visageModule.stepUIData[params.grapesProjectId];
				break;
			case VisageEditorWindowModes.Template:
				oldData = store.getState().visageModule.uiTemplateData[params.grapesProjectId].content;
				break;
			default:
				throw new Error("Unsupported editor mode: " + editorMode);
		}

		super(
			[params.grapesProjectId, params.newData, editorMode],
			[params.grapesProjectId, oldData, editorMode],
			params.actionName || `Set UI Data`,
			[params.newData, oldData, params.grapesProjectId],
		);
	}

	do(grapesProjectId: string, grapesProjectData: IGrapesJSProjectData, editorMode: VisageEditorWindowModes)
	{		
		// editing template means actions are temporary, always
		if(editorMode === VisageEditorWindowModes.Template)
		{
			this.flagAsTemporary();
		}

		switch(editorMode)
		{
			case VisageEditorWindowModes.Step:
				store.dispatch(StoreActions.visage.setStepUIData({ stepId: grapesProjectId, data: JsonCopy(grapesProjectData) }));
				break;
			case VisageEditorWindowModes.Template:
				const templateData = { ...store.getState().visageModule.uiTemplateData[grapesProjectId] };
				templateData.content = JsonCopy(grapesProjectData);
				store.dispatch(StoreActions.visage.setUITemplateData({ templateId: grapesProjectId, data: templateData }));
				break;
		}

		AssetsLibraryUtilities.refresh();
	}

	verify(newData: IGrapesJSProjectData, oldData: IGrapesJSProjectData, grapesProjectId: string)
	{
		if(!grapesProjectId) return false;
		
		return !deepEqual(newData, oldData);
	}
}